<template>
  <BaseTemplate>
    <div class="complete-user-register">
      <Title jpn="Member registration completed" />
      <div class="icon"><img src="/img/member_end.png"></div>
      <div class="description">
        <span class="text">Thank you for being a member!</span>
        <span class="text">We hope you continue to enjoy </span>
        <span class="text">your Gacha purchases!</span>
      </div>
      <SquareButton
        class="square-button"
        text="Home"
        @handleSquareBtnClick="goToUserLogin"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CompleteUserRegister',
  mixins: [t],

  beforeRouteLeave(to, from, next) {
    if (to.name === 'ConfirmUserRegister') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    Title,
    SquareButton,
  },

  methods: {
    goToUserLogin() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-user-register{
  width: 100%;
  min-height: 70vh;
  max-width: 1400px;
  padding: 70px 30px 0px;
  margin: 0px auto;
  text-align: center;
  .icon {
    margin-top: 20px;
    img {
      width: 244px;
    }
  }
  .description{
    display: flex;
    flex-direction: column;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    height: 113px;
    margin-top: 50px;
    .text{
      font-family: $notoSans;
      font-size: 18px;
      line-height: 1.6;
      color: $white;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 0px auto 0px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .complete-user-register{
    padding: 50px 30px 0px;
    .description{
      .text {
        font-size: 16px;
      }
    }
  }
}
</style>
